
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    select: {
        display: 'block',
        width: '100%',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingRight: '2em',
        paddingLeft: '10px',
        appearance: 'none',
        color: '#767676',
        transition: 'border-color 0.2s',
        border: '1px solid #aaa',
        borderRadius: '2px',
        backgroundColor: '#fff',
        lineHeight: 'normal'
    },
    disabledSelect: {
        display: 'block',
        width: '100%',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingRight: '2em',
        paddingLeft: '10px',
        appearance: 'none',
        color: '#767676',
        transition: 'border-color 0.2s',
        border: '1px solid #aaa',
        borderRadius: '2px',
        backgroundColor: '#fff',
        lineHeight: 'normal',
        opacity: 0.5
    },
    selectContainer: {
        position: 'relative',
        display: 'inline-block',
        verticalAlign: 'bottom',
        ':before': {
            content: '"\\25bc"',
            position: 'absolute',
            pointerEvents: 'none',
            color: '#767676',
            top: 0,
            bottom: '1px',
            paddingTop: '0.7em',
            lineHeight: 1,
            right: 0,
            width: '2em',
            textAlign: 'center',
            transform: 'scale(0.84, 0.42)',
            filter: 'progid:DXImageTransform.Microsoft.Matrix(M11=0.84, M12=0, M21=0, M22=0.42, SizingMethod="auto expand")',
        }
    },
    selectContainerBlock: {
        display: 'block',
        width: '100%'
    },
    text: {
        fontWeight: 300,
        color: '#484848',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        margin: '0px',
        wordWrap: 'break-word',
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: undefined,
        paddingTop: '0px',
        paddingBottom: '0px'
    },
    disabledText: {
        fontWeight: 300,
        color: '#484848',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        margin: '0px',
        wordWrap: 'break-word',
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: undefined,
        paddingTop: '0px',
        paddingBottom: '0px',
        opacity: 0.5
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Dropdown/styles.js